module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("I know I’ve forgotten to mention someone so forgive me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("To all at AM for putting up with me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("To Mary and Emma for beating me into shape with the book. To Mr D’Arcy and Mr Kennedy for stepping up to the mark when I asked for help. To the Mulryan, who will someday go electric. To Joyce, the Scottish angel and my siblings Aisling and Malcolm, you know you kept me sane, somewhat. To Jason in Malta, a true gentleman. To my music icon, Peter, and Lorraine, the insightful. To Moayyad for never forgetting. Rockin’ Barry for making Ziggy and Ralph thrive; you are a Rockstar. To Damien Griffin, for making me look beautiful in the cover photo! To the wise Chris, may his coffee always flow. To Brian, my mate, who will never forgive Wigan, but we’ll never forget Moscow and my first-class flight back home. To my departed buddy Allan, never forgotten. To Pattie and the G Man, beautiful souls. To Des, who always believed. To Jenny and my pal Peter. To all at UHL and the NRH who saved my life. I’m only the sum of the parts and part of the sum. I’ll never forget. Now, I need to stop all this fluffy stuff and you, get reading.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0